// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2j-kT","left":"StickyBox_left__3RTqN","right":"StickyBox_right__3XcED"};